import { createAction, handleActions } from '@tkit/actions';
import { IInitialState } from './initialState';

export const BREADCRUMB = 'common/BREADCRUMB';

export const doBreadcrumb = (breadcrumbs: IBreadcrumbState['breadcrumbs']) =>
  createAction(BREADCRUMB, { breadcrumbs });
export type doBreadcrumbActionType = ReturnType<typeof doBreadcrumb>;

export interface IBreadcrumbState {
  // use Readonly
  // doBreadcrumb: Readonly<{}>
  breadcrumbs: { path: string; breadcrumbName: string }[];
}

export const pureBreadcrumbState: IBreadcrumbState = {
  breadcrumbs: []
};

export const applyBreadcrumb = handleActions(
  {
    [BREADCRUMB]: (state: IInitialState, action: doBreadcrumbActionType) => {
      return {
        ...state,
        ...action.payload
      };
    }
  },
  pureBreadcrumbState
);
